var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shatter-stacked-bar-chart"},[(!!_vm.title)?_c('app-sub-title',{attrs:{"text":_vm.title}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"shatter-pie-chart__pie"},[_c('GChart',{attrs:{"type":"ColumnChart","data":_vm.chartData,"options":_vm.chartOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }